import React from "react";
import { Link } from "react-router-dom";
import { useMediaQuery, useTheme } from "@mui/material";
import PhoneBanner from "../Assets/home-herosection.png";
import "../CSS/HomeBanner.css";

const HomeBanner = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <section className="hero-section">
            {/* Background blobs */}
            <div className="hero-blob hero-blob-1" />
            <div className="hero-blob hero-blob-2" />
            <div className="hero-blob hero-blob-3" />

            <div className="hero-container">

                {/* ── Left: Copy ── */}
                <div className="hero-copy" style={{ order: isMobile ? 2 : 1 }}>

                    {/* Heading */}
                    <h1 className="hero-heading">
                        Create Your Perfect <br />
                        <span className="hero-heading-highlight">Digital Wedding Invitation</span>
                    </h1>

                    {/* Sub */}
                    <p className="hero-sub">
                        Create your digital wedding invitation easily.
                        Share via WhatsApp with RSVP features,
                        event location, and many more exciting features.
                    </p>

                    {/* CTA */}
                    <div className="hero-cta-row">
                        <Link to="/catalog" className="hero-btn-primary">
                            Order Now
                        </Link>

                    </div>

                </div>

                {/* ── Right: Visual ── */}

                <div className="hero-visual" style={{ order: isMobile ? 1 : 2 }}>
                    {/* glass backdrop */}
                    <div className="hero-visual-bg" />
                    <img
                        src={PhoneBanner}
                        alt="Kad Kahwin Digital pada Telefon"
                        className="hero-image"
                    />
                </div>


            </div>
        </section>
    );
};

export default HomeBanner;
